import { Box } from '@opendoor/bricks-next';
import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';
import dynamic from 'next/dynamic';

import { BuyWithConfidence } from '../BuyWithConfidence';
import { PropertyDetailsType } from '../types';

interface PropertyCTAsProps {
  property: PropertyDetailsType;
}

const BuyDirectCTA = dynamic(() => import('../BuyDirectCTA').then((mod) => mod.BuyDirectCTA), {
  ssr: false,
});

export const PropertyCTAs = ({ property }: PropertyCTAsProps) => {
  const { isActionable, tourKind } = determinePropertyActionability(property);

  if (!isActionable || !tourKind) {
    return null;
  }

  return (
    <Box tag="menu" px={0} mt="$24x" mb={0} gap="$24x">
      <BuyDirectCTA property={property} />
      {property.shouldShowGuarantee && <BuyWithConfidence />}
    </Box>
  );
};
